import React from 'react';
import { connect } from 'react-redux'
import { CategoryList, MessageList, MessageDetails } from 'MessageCenter'
import styles from './MessageCenter.module.css'

class MessageCenter extends React.Component {
    render() {

        return (
            <div className={styles.message_center_wrapper}>
                <div className={styles.message_center_categories}>
                    <CategoryList selectedCategory={this.props.selectedCategory} />
                </div>
                <div className={styles.message_center_message_list}>
                    <MessageList selectedCategory={this.props.selectedCategory} />
                </div>
                <div className={styles.message_center_message_details}>
                    <MessageDetails selectedCategory={this.props.selectedCategory} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {

    return {
        selectedCategory: state.ui.messageCenter.selectedCategory
    };
}

const connectedMessageCenter = connect(mapStateToProps)(MessageCenter);
export { connectedMessageCenter as MessageCenter };
